export default __webpack_public_path__ + "static/media/close-button.e15732ec.svg";